import { useEffect } from "react";
import { debounce } from "lodash";
import { Box, Text, Image, Center } from "@chakra-ui/react";
import image1 from "../images/hypospadiaslogo.png";
import image2 from "../images/penileModel.jpg";
import image3 from "../images/difference.jpg";
import Introduction from "../introduction/introduction";
import HowItWorks from "../how-it-works/howItWorks";
import SupportedPlatforms from "../supported-platforms/supportedPlatforms";
import WhoWeAre from "../who-we-are/whoWeAre";
import Collaborate from "../collaborate/collaborate";
import Literature from "../literature/literature";
import ScrollAnimation from "react-animate-on-scroll";
import { useHomepageContext } from "./homepageContext";
import "./home.css";
import Footer from "../footer/footer";

const HomeImage = () => {
  return (
    <Box alignItems='center'>
      <Center>
        <Image
          src={image2}
          alt='penile-model-ai'
          width={{ base: "90%", md: "77%", lg: "77%" }}
          mt={5}
          borderRadius={3}
        />
      </Center>
    </Box>
  );
};

const DifferenceImage = ({ id }) => {
  return (
    <Box alignItems='center' mt='80px' mb='80px' id={id}>
      <Center>
        <Text
          color='white'
          fontSize={{ base: "xl", md: "3xl", lg: "4xl" }}
          fontWeight={700}
        >
          Making A Difference To Healthcare
        </Text>
      </Center>
      <Center>
        <Image
          src={image3}
          alt='making-a-difference-in-healthcare'
          width={{ base: "90%", md: "77%", lg: "77%" }}
          mt={5}
          borderRadius={3}
        />
      </Center>
    </Box>
  );
};

export default function Home() {
  const { setActiveSection } = useHomepageContext();
  useEffect(() => {
    const sections = document.querySelectorAll("[data-section='true']");
    document.addEventListener(
      "scroll",
      debounce(() => {
        for (const section of sections) {
          // const navItem = document.querySelector(
          //   `.nav-menu li a[data-hash='#${section.id}']`
          // );
          let top = section.offsetTop;
          let bottom = top + section.offsetHeight;
          let scrolled = window.scrollY;

          if (top <= scrolled && bottom > scrolled) {
            setActiveSection(section.id);
          }
        }
      }),
      10,
      false
    );
    //eslint-disable-next-line
  }, []);

  return (
    <div id='home'>
      <Box
        display='flex'
        justifyContent='space-between'
        flexDir='row'
        align-items='center'
        width={{ base: "90%", md: "77%", lg: "77%" }}
        ml='auto'
        mr='auto'
      >
        <Box display='flex' flexDir='row' align-items='flex-start' pt='22px'>
          <Text
            color='white'
            fontSize={{ base: "2xl", md: "3xl", lg: "4xl" }}
            fontWeight={700}
          >
            TRANSFORMING HEALTHCARE FOR HYPOSPADIAS WITH ARTIFICIAL INTELLIGENCE
          </Text>
        </Box>

        <Box display='flex' flexDir='column' alignItems='flex-end'>
          <Image
            src={image1}
            alt='hypospadias-ai-logo'
            width={{ base: "86%", md: "67%", lg: "77%" }}
          />
          <Text
            color='white'
            fontSize='15px'
            textAlign='justify'
            width={{ base: "83%", md: "70%", lg: "76%" }}
          >
            Our marking algorithm analyses and defines the quality of
            hypospadias urethral plate. All whilst ensuring impressive speed and
            accuracy, through accumulating over a thousand images- all of which
            are reviewed by experienced pediatric urologists around the globe.
          </Text>
        </Box>
      </Box>

      <HomeImage />

      <ScrollAnimation animateIn='fadeIn' animateOnce={true}>
        <Introduction id='introduction' data-section='true' />
      </ScrollAnimation>
      <ScrollAnimation animateIn='fadeIn' animateOnce={true}>
        <DifferenceImage />
      </ScrollAnimation>

      <ScrollAnimation animateIn='fadeIn' animateOnce={true}>
        <HowItWorks id='how-it-works' data-section='true' />
      </ScrollAnimation>

      <ScrollAnimation animateIn='fadeIn' animateOnce={true}>
        <SupportedPlatforms id='supported-platforms' data-section='true' />
      </ScrollAnimation>
      <ScrollAnimation animateIn='fadeIn' animateOnce={true}>
        <WhoWeAre id='who-we-are' data-section='true' />
      </ScrollAnimation>

      <ScrollAnimation animateIn='fadeIn' animateOnce={true}>
        <Collaborate id='collaborate' data-section='true' />
      </ScrollAnimation>

      <ScrollAnimation animateIn='fadeIn' animateOnce={true}>
        <Literature id='literature' data-section='true' />
      </ScrollAnimation>

      <Footer />
    </div>
  );
}
